import React from 'react';
import PropTypes from 'prop-types';

import { ICheckboxProps } from '../../constants/commonTypes';
import { Checkbox as MUICheckbox } from '@material-ui/core';


const Checkbox = (props: ICheckboxProps) => {
  const { checked, onChange, ...rest } = props
  return (
    <MUICheckbox checked={checked} onChange={onChange} {...rest} />
  )
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func
}

Checkbox.defaultProps = {
  checked: false,
  onChange: () => { }
}

export default Checkbox;